import { connect } from 'react-redux'

import component from 'components/Pricelist'

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch
})

const mapStateToProps = (state, ownProps) => ({
  staging: state.staging,
  options: state.options,
  uoms: state.uoms,
  pricelist: state.pricelist,
  products: state.products,
  date: ownProps.params.date || 'today',
  isLoggedIn: state.auth && state.auth.isLoggedIn,
  isAdmin: state.auth && state.auth.isAdmin,
  user: state.auth && state.auth.user
})

export default connect(mapStateToProps, mapDispatchToProps)(component)



// WEBPACK FOOTER //
// ./src/routes/DailyProducts/containers/PricelistContainer.js